
import React from 'react';
import { Link } from 'react-router-dom';

const InvestmentHero: React.FC = () => {
  return (
    <section className="relative bg-gradient-to-br from-emerald-50 to-teal-50 py-20">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/6721b9da62c1b05204184d0b049c2c0d.jpg')`
        }}
      />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
            Glamping Investment Opportunities
          </h1>
          <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto">
            Join the outdoor hospitality revolution with OED Glamping Retreat Developments. 
            Discover profitable investment opportunities in premium glamping properties.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/start-investing"
              className="bg-emerald-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Start Investing Today
            </Link>
            <Link
              to="/investment-packages"
              className="border border-emerald-600 text-emerald-600 px-8 py-4 rounded-lg font-semibold hover:bg-emerald-600 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
            >
              View Investment Packages
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InvestmentHero;
